import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

type SpinnerProps = {
  size?: number;
  color?: string;
  backgroundColor?: string;
};

const Spinner = (props: SpinnerProps) => {
  const size = props.size ?? 48;
  return (
    <Loader
      style={{
        width: `${size}px`,
        height: `${size}px`,
        border: `${size * 0.1}px solid ${props.backgroundColor ?? '#fff'}`,
        borderBottomColor: `${props.color ?? '#000'}`,
      }}
    />
  );
};

export default Spinner;

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Loader = styled.span`
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: ${rotation} 1s linear infinite;
`;
